import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { child, get, getDatabase, ref as refDb, set } from "firebase/database";

export const builderAPI = {
    async publishSongAPI(files, schemaString, artist, title, art) {
        try {
            const storage = getStorage()
            const schemaBoolean = {}

            for (const schema in files) {
                const file = files[schema]
                const storageRef = ref(storage, `${artist}/${title}/` + file[0].name);
                let metadata = {
                    contentType: 'audio/mpeg',
                }
                const snapshot = await uploadBytes(storageRef, file[0], metadata)
                const url = await getDownloadURL(snapshot.ref)
                schemaBoolean[schema] = url
            }

            let artUrl
            if (art) {
                const artStorageRef = ref(storage, `${artist}/` + 'cover.jpg')
                let metadata = {
                    contentType: 'image/jpeg',
                }
                const snapshot = await uploadBytes(artStorageRef, art, metadata)
                artUrl = await getDownloadURL(snapshot.ref)
            } else {
                artUrl = null
            }

            const db = getDatabase();
            set(refDb(db, `${artist}/${title}/`), {
                schemaBoolean: schemaBoolean,
                schemaString: schemaString,
                artist: artist,
                title: title,
                art: artUrl
            })
        } catch (e) {
            throw e
        }
    }
}